import React from 'react'
import PropTypes from 'prop-types'

const CombinedField = props => {
  const { resource, children, label, cellName, record, tag: Tag, ...attributes } = props

  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, {
      record,
      resource,
    }),
  )

  return <Tag {...attributes}>{childrenWithProps}</Tag>
}

CombinedField.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
}

CombinedField.defaultProps = {
  tag: 'div',
}

export default CombinedField



// WEBPACK FOOTER //
// ./ui/Data/CombinedField.js